export const API_ROOT = {
  osbod_salary:
    process.env.NODE_ENV === "production"
      ? "https://api.ministerie-owcs.cw/osbod_salary/prd/api"
      : "http://localhost:9006/osbod_salary/prd/api"
};
